<template>
    <div class="consultationRecord">
        <div class="navBox">
            <ul class="navRight">
                <router-link v-for="(item,index) in navRight" :key="index" tag="li" :to="item.path">{{item.name}}</router-link>
            </ul>
        </div>
        <router-view></router-view>
    </div>
</template>
<script>
export default {
    name: "mineHome",
    components: {
    },
    data() {
        return {
            navRight: [
                { name: '咨询记录', idx: '0', path: '/consultant/minestudent/main/consultationRecord/student' },
                // { name: '家长交流', idx: '1', path: '/consultant/minestudent/main/consultationRecord/parent' },
            ]
        }
    },
    methods: {
    },
}
</script>
<style scoped lang="less">
.consultationRecord {
    .navBox {
        background-color: #fff;
        padding: 10px 30px 24px 30px;

        .navRight {
            height: 55px;
            border-bottom: 1px solid rgba(217, 217, 217, 1);
            box-sizing: border-box;
            display: flex;
            li {
                box-sizing: border-box;
                height: 54px;
                line-height: 54px;
                font-size: 17px;
                font-weight: 500;
                margin-right: 60px;
                cursor: pointer;
            }
            .router-link-active {
                border-bottom: 2px solid #3D90F6;
                color: #3D90F6;
            }
        }
    }
}
</style>